import {fabric} from "fabric-with-gestures";

export default {
  methods:{
    getFreeTables() {
      let data = this.reservationInfo;
      let visitDatetime = this.reservationInfo.dateVisit + " " + this.reservationInfo.timeVisit;
      data.selectionTables = this.selectionTables;

      if (data.dateVisit && data.timeVisit && data.duration) {
        axios.post('/reservation/' + this.restaurantId + '/table-free', {
          dateTimeVisit: visitDatetime,
          duration: data.duration,
          restaurantId: this.restaurantId,
          exclude : data.exclude
        })
          .then(({data}) => {
            this.availableTable = data.data;
            this.availableTableIds = _.map(this.availableTable, 'id')
          })
      }
    },
    initCanvas() {
      this.canvas = new fabric.Canvas('schema', {
        containerClassName: 'schema',
        selectable:false,
        selection:false,
        perPixelTargetFind:true,
        controlsAboveOverlay:true,
        centeredScaling:true,
        allowTouchScrolling: true
      });
      if(this.restaurant.schema.length > 30){
        this.reRenderCanvas()
      }
      return this;
    }
  }
}
